import Vue from "vue";
import Vuetify from "vuetify/lib";
import '@/assets/styles/style.sass';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
    },
    icons: {
        iconfont: 'mdi',
    },
    options: {
        customProperties: true,
    },
});